import {templateFlagsConfig} from "../config/templateFlagsConfig";
import {appSettingsInterface} from "../config/appSettingsInterface";
import cloneDeep from "lodash/cloneDeep";
import {DrawingConfigurationInterface} from "../components/drawingComponent/interface/drawingConfigurationInterface";

/*
 * Main purpose of this class is to hide the abstraction for globalThis (window) object,
 * so later we don't have to use the "globalThis" everywhere in the code
 */
export class AppStateService {

    private readonly nfState: appSettingsInterface;

    constructor() {
        this.nfState = {
            initialProductDataStore: {},
            productDataStore: {},
            currentDrawingConfiguration: {},
            prices: {},
            appSettings: {
                templateFlags: templateFlagsConfig,
                isMobile: false,
                activeComponents: [],
                iccDrawing: true,
                debug: false,
            }
        }
    }

    initializeAppState()
    {
        globalThis.nfState = this.nfState;
    }

    getPrices()
    {
        return globalThis.nfState.prices;
    }

    setPrices(prices)
    {
        globalThis.nfState.prices = cloneDeep(prices);
    }

    getDrawingConfiguration(): DrawingConfigurationInterface
    {
        return globalThis.nfState.currentDrawingConfiguration;
    }

    getTemplateFlags(componentName: string)
    {
        return globalThis.nfState.appSettings.templateFlags[componentName];
    }

    getInitialProductDataStore()
    {
        return globalThis.nfState.initialProductDataStore;
    }

    getProductDataStore()
    {
        return globalThis.nfState.productDataStore;
    }

    getAppSettingsStore()
    {
        return globalThis.nfState.appSettings;
    }

    setInitialState(data)
    {
        globalThis.nfState.initialProductDataStore = cloneDeep(data);
    }

    setState(data)
    {
        globalThis.nfState.productDataStore = cloneDeep(data);
    }

    setCurrentDrawingConfiguration(configuration)
    {
        globalThis.nfState.currentDrawingConfiguration = cloneDeep(configuration);
    }

    getAppSettingOption(optionName :string)
    {
        return globalThis.nfState.appSettings[optionName];
    }

    setAppSettingOption(optionName :string, value)
    {
        return globalThis.nfState.appSettings[optionName] = value;
    }

    getAppSettingTemplateFlagsByModule(moduleName: string)
    {
        return globalThis.nfState.appSettings.templateFlags[moduleName];
    }

    setAppSettingTemplateFlag(componentName :string, flagName :string, value :any)
    {
        globalThis.nfState.appSettings.templateFlags[componentName][flagName] = value;
    }

    validate(data)
    {
        if (data.data[0].relationships === undefined) {
            throw new Error("Sorry, relationships parameter does not exist");
        }
    }
 }
